import React from 'react';
import TransitionLink from './TransitionLink';

const LightFooter = ({ showFullPortfolioLink = true, fullPortfolioLabel }) => {
    return (
        <div className="mt-16 pt-8 border-t border-white/10 flex items-center justify-between">
            <span className="text-white/20 text-sm font-mono">Paolo Allegretti</span>
            {showFullPortfolioLink && (
                <TransitionLink to="/" className="text-white/20 text-sm font-mono hover:text-white/50 transition-colors duration-300">
                    {fullPortfolioLabel} →
                </TransitionLink>
            )}
        </div>
    );
};

export default LightFooter;
